// features/petForm/eventFormSlice.js
// Slice for the forms comtrol. Using in form components - ...

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mode: 'add', // 'add' | 'edit'
  data: {
    petId: '',
    petName: '',
    eventType: '',
    medication: '',
    note: '',
    date: '',
    time: '', // HH:mm события; '' — не задано (старые события)
    repeat: '',
    repeatTime: '', // HH:mm следующего события; '' — как у события
    remind: '',
    remindTime: '', // своё время напоминания; '' — как у события, к которому оно относится
    currentRemind: '',
    currentRemindTime: '', // своё время напоминания о текущем событии (edit)
  },
};

export const eventFormSlice = createSlice({
  name: 'eventForm',
  initialState,
  reducers: {
    setEventFormMode: (state, action) => {
      state.mode = action.payload; // 'add' or 'edit'
    },
    updateEventFormField: (state, action) => {
      const { field, value } = action.payload;
      state.data[field] = value;
    },
    setEventFormData: (state, action) => {
      state.data = action.payload; // for loading pet data from petsSlice for editing
    },
    resetEventForm: (state) => {
      state.mode = 'add';
      state.data = {
        petId: '',
        petName: '',
        eventType: '',
        medication: '',
        note: '',
        date: '',
        time: '',
        repeat: '',
        repeatTime: '',
        repeatType: '',
        remind: '',
        remindTime: '',
        remindType: '',
        currentRemind: '',
        currentRemindTime: '',
      };
    },
  },
});

export const {
  setEventFormMode,
  updateEventFormField,
  setEventFormData,
  resetEventForm,
} = eventFormSlice.actions;

export const selectEventForm = (state) => state.eventForm;
export const selectEventFormData = (state) => state.eventForm.data;
export const selectEventFormMode = (state) => state.eventForm.mode;

export default eventFormSlice.reducer;
